import { FETCH_DEVICES, CLEAR_DEVICE } from './constants'

export const clearDevice = () => ({ type: CLEAR_DEVICE })
export const fetchDevices = {
  request: customer => ({
    type: FETCH_DEVICES['REQUEST'],
    customer
  }),
  success: devices => ({ type: FETCH_DEVICES['SUCCESS'], devices })
}



// WEBPACK FOOTER //
// ./src/containers/DeviceSelector/actions.js